import { register, findAll } from '../../../../Javascript/Sysmex/Utils'

const SocialMediaBar = el => {
  const fbPopups = findAll('[data-eventlistener="js-popup-fb"]')
  const twitterPopups = findAll('[data-eventlistener="js-popup-tw"]')

  const openPopup = (url, top, left, width, height, withScroll, withResize) => {
    const showScroll = (withScroll === 1) ? 'yes' : 'no'
    const doResize = (withResize === 1) ? 'yes' : 'no'
    const windowName = width + 'x' + height
    let windowAttrs = 'menubar=no,location=no,directories=no,toolbar=no'
    windowAttrs += 'screenX=' + left + ',screenY=' + top + ',width=' + width + ',height=' + height + ',scrollbars=' + showScroll + ',resizable=' + doResize
    const windowPopup = window.open(url, windowName, windowAttrs)
    if (windowPopup !== null) {
      windowPopup.focus()
    }
  }

  fbPopups.forEach(linkTag => {
    linkTag.addEventListener('click', event => {
      event.preventDefault()
      const url = linkTag.getAttribute('href')
      openPopup(url, 0, 0, 650, 425, 0, 0)
    })
  })

  twitterPopups.forEach(linkTag => {
    linkTag.addEventListener('click', event => {
      event.preventDefault()
      const url = linkTag.getAttribute('href')
      openPopup(url, 0, 0, 550, 485, 0, 0)
    })
  })
}

register('SocialMediaBar', SocialMediaBar)
